<template>
  <!-- Begin Page Content -->
  <div class="container-fluid">
    <row class="row justify-content-center">
      <div class="col-10">
        <div
          class="card"
          v-if="
            lessonCategories &&
            lessonCategories.length > 0 &&
            lessons != null &&
            lessons.length > 0
          "
        >
          <div class="card-header">
            <h4 class="text-primary font-weight-bold">
              Улирлын дүн ({{ this.lessons.length }})
            </h4>
          </div>
          <div class="card-body">
            <table class="table table-bordered">
              <th class="p-0" style="width: 1%">№</th>
              <th>Name</th>
              <th class="text-center">Багш</th>
              <th class="text-center">Төрөл</th>
              <!-- <th class="text-center">Ангиар/Группээр</th> -->
              <th class="text-center">Дүн</th>
              <th class="text-center">Түвшин</th>
              <th class="text-center">Жилийн дүн</th>
              <th class="text-center">Түвшин</th>
              <tr
                v-for="(category, index) in lessonCategories"
                :key="category.id"
              >
                <td class="py-0 text-center">{{ index + 1 }}</td>
                <td
                  class="py-0"
                  style="color: black; font-weight: bold"
                  @click="_detail(category)"
                >
                  {{ category.name }}
                </td>
                <td class="py-0">{{ _getTeachers(category)[0] }}</td>
                <td class="py-0 text-center">
                  <span
                    class="badge badge-must"
                    style="font-size: 8pt"
                    v-if="category.typeDetail.id == 'zaaval'"
                    >{{ category.typeDetail.name }}</span
                  >
                  <span
                    class="badge badge-select"
                    style="font-size: 8pt"
                    v-else
                    >{{ category.typeDetail.name }}</span
                  >
                </td>
                <!-- <td class="text-center">
                  {{category.index}}
                   
                </td> -->
                <!-- <span v-if="lesson.isGroup" class="badge badge-danger">группээр</span>
                    <span v-else class="badge badge-primary">ангиар</span>      -->
                <td class="py-0 text-center">
                  {{ _getCategoryScore(category, 1) }}
                </td>

                <td class="py-0 text-center" style="color: black">
                  {{ getXRomNumber(getXLevel(_getCategoryScore(category, 1))) }}
                </td>
                <td class="py-0 text-center">
                  {{ _getCategoryFinalYearScore(category)[0] }}
                </td>
                <td class="py-0 text-center" style="color: black">
                  {{
                    getXRomNumber(
                      getXLevel(_getCategoryFinalYearScore(category)[0])
                    )
                  }}
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div v-else-if="loading == false" class="text-center alert alert-info">
          Танд одоогоор дүн байxгүй байна!
        </div>
        <div
          v-if="loading == true"
          style="position: fixed; z-index: 10000000; top: 45%; left: 45%"
        >
          <div class="spinner-grow text-primary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <div class="spinner-grow text-secondary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <div class="spinner-grow text-success" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <div class="spinner-grow text-danger" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <div class="spinner-grow text-warning" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <div class="spinner-grow text-info" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <div class="spinner-grow text-dark" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
    </row>
  </div>
  <!-- /.container-fluid -->
</template>

<script>
const fb = require("../firebaseConfig.js");
import { mapState } from "vuex";
import myfunction from "./global/myfunction.js";

export default {
  name: "AllLessonStudentScores",
  data() {
    return {
      msg: "Hellow",
      lessons: [],
      trending: {
        content: [],
      },
      school: null,
      loading: false,
      student: null,
      schoolId: null,
      lessonCategories: [],
    };
  },
  mixins: [myfunction],
  created() {
    this._getInitData();
  },
  computed: {
    ...mapState(["currentUser"]),
  },
  methods: {
    _detail(category) {
      console.log(category.lessons[0]);
    },
    _getTeachers(category) {
      var teachers = [];
      for (var lesson of category.lessons) {
        if (lesson.finalGrade != null && lesson.finalGrade.finalScore != null)
          teachers.push(this.getXTeacherName(lesson));
      }
      return teachers;
    },
    _getCategoryScore(category, semesterNumber) {
      var score = null;
      for (var lesson of category.lessons) {
        if (lesson.scores != null && lesson.scores != undefined) {
           console.log(lesson.scores[semesterNumber - 1]);
          score = lesson.scores[semesterNumber - 1].finalScore;
         
        }
      }
      return score;
    },
    _getCategoryFinalYearScore(category) {
      var scores = [];
      for (var lesson of category.lessons) {
        if (lesson.finalGrade && lesson.finalGrade.finalYearScore)
          scores.push(parseInt(lesson.finalGrade.finalYearScore));
      }
      return scores;
    },

    _sortedEndCategoryDataArray: function () {
      function compare(a, b) {
        if (a.index < b.index) return -1;
        if (a.index > b.index) return 1;
        return 0;
      }
      return this.lessonCategories.sort(compare);
    },
    async _checkCategory(categoryDoc, lesson) {
      var foundData = null;
      for (var i = 0; i < this.lessonCategories.length; i++) {
        var data = this.lessonCategories[i];
        if (data.id == categoryDoc.id) {
          foundData = data;
          break;
        }
      }
      if (foundData == null) {
        let foundData = categoryDoc.data();
        foundData.id = categoryDoc.id;
        foundData.lessons = [];
        foundData.lessons.push(lesson);
        this.lessonCategories.push(foundData);
      } else {
        foundData.lessons.push(lesson);
      }
      return foundData;
    },
    async _findCategory(schoolId, lesson) {
      var catRef = await fb.db
        .collection("schools/" + schoolId + "/categories")
        .doc(lesson.category.id)
        .get();
      if (catRef.exists) {
        lesson.categoryTypeId = catRef.data().typeDetail.id;
        lesson.categoryTypeName = catRef.data().typeDetail.name;
        lesson.categoryData = catRef.data();
        lesson.categoryId = catRef.id;
        this._checkCategory(catRef, lesson);
        this._sortedEndCategoryDataArray();
      }
    },

    async _getLesssonTest() {
      await fb.db
        .collection("/schools/" + this.schoolId + "/lessons")
        .where(
          "programIds",
          "array-contains",
          this.student["program-" + this.school.currentYear].id
        )
        .get()
        .then((lessonDocs) => {
          lessonDocs.forEach(async (lessonDoc) => {
            let lesson = lessonDoc.data();
            lesson.id = lessonDoc.id;
            lesson.ref = lessonDocs.ref;
            // var parentLes = await lesson.category.get();
            // lesson.bgColor = parentLes.data().bgColor;
            // lesson.foreColor = parentLes.data().foreColor;

            if (lesson.category && lesson.category.id) {
              await this._findCategory(this.schoolId, lesson);
            }

            await this.student.ref
              .collection("/finalGrades")
              .doc(lesson.id)
              .get()
              .then((docData) => {
                if (docData.data() != undefined)
                  lesson.scores = docData.data().scores;
                else lesson.scores = null
                console.log(docData.data());
              });
            this.lessons.push(lesson);
          });
        });
    },
    async _getLessons() {
      var _this = this;
      if (this.currentUser != null) {
        await fb.usersCollection
          .doc(this.currentUser.uid)
          .get()
          .then((userData) => {
            if (
              userData != null &&
              userData.exists &&
              userData.data().role != null &&
              userData.data().role == "student" &&
              userData.data().customer != null
            ) {
              this.loading = true;
              userData
                .data()
                .customer.get()
                .then(async (stData) => {
                  if (
                    stData != null &&
                    stData.exists &&
                    stData.data() &&
                    stData.data().school &&
                    stData.data().program
                  ) {
                    _this.school = stData.data().school;
                    _this.schoolId = stData.data().school.id;
                    _this.student = stData.data();
                    _this.student.id = stData.id;
                    _this.student.ref = stData.ref;
                    this.loading = false;
                  }
                });
            } else this.loading = false;
          });
      }
    },

    async _getInitData() {
      var userDoc = await fb.usersCollection.doc(this.currentUser.uid).get();
      console.log(userDoc.data());
      if (
        userDoc.exists &&
        userDoc.data().role != null &&
        userDoc.data().role == "student" &&
        userDoc.data().customer != null
      ) {
        var studentDoc = await userDoc.data().customer.get();
        if (studentDoc.exists) {
          var x = await studentDoc.data().school.get();
          let school = x.data();
          school.ref = x.ref;
          school.id = x.id;
          this.school = school;
          console.log(this.school);
          this.schoolId = this.school.id;
          this.student = studentDoc.data();
          this.student.id = studentDoc.id;
          this.student.ref = studentDoc.ref;
        }
      }
      console.log(this.student);
      await this._getLesssonTest();
      console.log(this.lessons.length);
    },
    _getScore(score) {
      if (score == null) return "Багшаасаа асууна уу";

      if (score > 91)
        return (
          "<span class='bg-success px-2' style='color:white'>" +
          score +
          "</span>"
        );
      else if (score > 81)
        return "<span class='bg-info px-2'>" + score + "</span>";
      else if (score > 71)
        return (
          "<span class='px-2' style='background:#a0b8ff; color:black'>" +
          score +
          "</span>"
        );
      else if (score > 61)
        return (
          "<span class='px-2' style='background: #ffffd3; color:black'>" +
          score +
          "</span>"
        );
      else
        return (
          "<span class='px-2' style='background:#ffb5ae; color:black;'>" +
          score +
          "</span>"
        );
    },
    _getColor(lesson) {
      var colorText = "";
      if (lesson.bgColor == undefined) {
        colorText = colorText + "background-color:#fff;";
      } else {
        colorText = colorText + "background-color:" + lesson.bgColor;
      }
      return colorText;
    },
    _getTextColor(lesson) {
      var colorText = "";

      if (lesson.foreColor == undefined) {
        colorText = colorText + "color:#4e73df;";
      } else {
        colorText = colorText + "color:" + lesson.foreColor;
      }
      return colorText;
    },
    async _getFinalGrade(lesson) {
      // /schools/xUSN7smB3EcLwDYhs1Y9/students/yTy8ea67yDuyQXO8uJxI/finalGrades/7K5fdDd8BPROJgS91nAJ

      console.log(this.student.id);
    },

    goDetail(lesson) {
      if (lesson && lesson.id) {
        this.$router.push({
          name: "LessonDetailForStudent",
          params: { lessonId: lesson.id, schoolId: this.school.id, sts: false },
        });
      }
    },
  },
};
</script>
<style>
.card-img-top {
  object-fit: cover !important;
  /* max-height: 165px!important; */
}
</style>